// import Vue from 'vue';
// import VueAnalytics from 'vue-analytics';

// const GA = function () {
//     Vue.use(VueAnalytics, {
//         id: 'UA-34371062-1',
//         commands: {
//             ga(binding) {
//                 console.log(binding);
//                 this.$ga.event({
//                     eventCategory: binding.category,
//                     eventAction: binding.action,
//                     eventLabel: binding.label,
//                 });
//             },
//         },
//     });
// };

// export { GA };

import analyticsHelpers from '../helpers/analytics-helpers';

// Initialize the GA events directive.
const gaEvent = {
  bind(el, binding) {
    el.addEventListener('click', () => {
      analyticsHelpers.gaEvent(binding.value.category, binding.value.action, binding.value.label);
    }, false);
  },
};

export {
  gaEvent,
};
